import React, { useEffect, useState, useRef, useCallback } from "react";
import CustomCollapsableCard from "../../components/common/CustomCollapsableCard";
import DMQCustomCard from "../../components/common/DMQCustomCard";
// import { Button } from "@digitallabs/one-x-ui";
import { Button } from "../../resourses/digitallabs/one-x-ui";
import SystemFetchDetails from "../../components/common/SystemFetchDetails";
import DynamicSummaryRenderer from "../../components/dynamicRendering/DynamicSummaryRenderer";
import OtpVerificationModal from "../../components/common/OTPVerificationModal";

import {
  saveStepData,
  getStoredFormData,
  saveCurrentStep,
  saveCurrentInternalStep,
  getUser,
  getQuestionBank,
  setPDFPresent,
  getCurrentQuestionSetId,
} from "../../utils/formStorage";

import { useLoader } from "../../context/LoaderContext";
import { DMQStepNames, MAIN_STEPS } from "../../constants/constants";
import { questionAnswerMapper } from "../questionAnswerMapper/questionAnswerMapper";
import { showCatchError } from "../../utils/toastMessageUtil";
import { sendMemberResponse } from "../../services/serviceCollections/dmqService";
import { loginGenerateOTP } from "../../services/serviceCollections/otpService";
import { maskingUtil } from "../../utils/maskingUtil";
import { getClientInfo } from "../../utils/getClientInfo";
import { checkUserInactivity } from "../../utils/checkUserInactivity";
import { withAuth } from "../../utils/withAuth";
import { appRouter } from "../../constants/routerConstant";
import { useNavigate } from "react-router-dom";
import { getAuthMemberData } from "../../utils/authStorage";
import DynamicFormRenderer_Helix from "../../components/dynamicRendering/DyamicFormRenderer_Helix";
import FormFooter from "../../components/common/FormFooter";
import { decrypt } from "../../utils/cryptoUtil";

const StepConfirmDetails = ({ handleStepChange }) => {
  const { setLoading } = useLoader();
  const formRef = useRef(null);
  const navigate = useNavigate();

  const questionBank = getQuestionBank();

  const [renderingJSON, setRenderingJSON] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isSystemExpanded, setIsSystemExpanded] = useState(true);
  const [formState, setFormState] = useState({});
  const [fullDMQData, setFullDMQData] = useState(null);

  const [showNRI, setShowNRI] = useState(false);
  const [showFN, setShowFN] = useState(false);
  const [showDiabetic, setShowDiabetic] = useState(false);
  const [showHighBP, setShowHighBP] = useState(false);
  const [showThyroid, setShowThyroid] = useState(false);
  const [showKidney, setShowKidney] = useState(false);
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [memberDetails, setMemberDetails] = useState(null);

  const handleChange = useCallback((name, value) => {
    setFormState((prev) => {
      if (Object.is(prev[name], value)) return prev;
      return {
        ...prev,
        [name]: value,
      };
    });

    saveStepData(DMQStepNames.DECLARATION, { [name]: value });
  }, []);

  useEffect(() => {
    const init = async () => {
      setLoading(true);

      saveCurrentStep(MAIN_STEPS.CONFIRM_DETAILS);

      const user = await getAuthMemberData();
      setMemberDetails(user);

      setRenderingJSON(questionBank[DMQStepNames.DECLARATION]);

      populateFormData();

      setLoading(false);
    };

    init();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const populateFormData = () => {
    const stored = getStoredFormData();
    setFullDMQData(stored);

    const fullName = stored?.[DMQStepNames.PERSONAL_DETAILS]?.name;

    const NRIData = stored?.[DMQStepNames.NRI_QUESTIONNAIRE];
    setShowNRI(NRIData && Object.keys(NRIData).length > 0 ? true : false ? true : false);

    const FNData = stored?.[DMQStepNames.FOREIGN_NATIONAL_QUESTIONNAIRE];
    setShowFN(FNData && Object.keys(FNData).length > 0 ? true : false ? true : false);

    const diabeticData = stored?.[DMQStepNames.DIABETIC_QUESTIONNAIRE];
    setShowDiabetic(diabeticData && Object.keys(diabeticData).length > 0 ? true : false);

    const highBPData = stored?.[DMQStepNames.BLOOD_PRESSURE_QUESTIONNAIRE];
    setShowHighBP(highBPData && Object.keys(highBPData).length > 0 ? true : false);

    const thyroidData = stored?.[DMQStepNames.THYROID_QUESTIONNAIRE];
    setShowThyroid(thyroidData && Object.keys(thyroidData).length > 0 ? true : false);

    const kidneyData = stored?.[DMQStepNames.KIDNEY_QUESTIONNAIRE];
    setShowKidney(kidneyData && Object.keys(kidneyData).length > 0 ? true : false);

    saveStepData(DMQStepNames.DECLARATION, { fullName });

    if (stored?.[DMQStepNames.DECLARATION]) {
      setFormState(stored[DMQStepNames.DECLARATION]);
    }
  };

  const onFinish = async (values) => {
    setLoading(true);

    saveStepData(DMQStepNames.DECLARATION, values);

    const payload = {
      emp_id: memberDetails?.empCode,
      dob: memberDetails?.dob,
      corp_id: parseInt(memberDetails?.corpId),
      isForSubmission: true,
    };

    try {
      const result = await loginGenerateOTP(payload);

      if (result.message === "OK") {
        setShowOTPModal(true);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      showCatchError(error.message || error);
    }
  };

  const handleToggle = (key) => {
    if (activeIndex === key) {
      setActiveIndex(null);
    } else {
      setActiveIndex(key);
      setIsSystemExpanded(false);
    }
  };

  const handleSystemToggle = () => {
    setIsSystemExpanded((prev) => {
      const newState = !prev;
      if (newState) setActiveIndex(null);
      return newState;
    });
  };

  const editInformation = (step, internalStep) => {
    saveCurrentInternalStep(internalStep);
    handleStepChange(step);
  };

  const sections = [
    {
      key: "address",
      title: "Address Details",
      step: MAIN_STEPS.PERSONAL_DETAILS,
      internalStep: 2,
      schema: questionBank[DMQStepNames.ADDRESS_DETAILS],
      values: fullDMQData?.[DMQStepNames.ADDRESS_DETAILS],
    },
    {
      key: "general",
      title: "General Questionnaire",
      step: MAIN_STEPS.MEDICAL_HISTORY,
      internalStep: 1,
      schema: questionBank[DMQStepNames.GENERAL_HISTORY],
      values: fullDMQData?.[DMQStepNames.GENERAL_HISTORY],
    },
    {
      key: "medical",
      title: "Medical History",
      step: MAIN_STEPS.MEDICAL_HISTORY,
      internalStep: 2,
      schema: questionBank[DMQStepNames.MEDICAL_HISTORY],
      values: fullDMQData?.[DMQStepNames.MEDICAL_HISTORY],
    },
    {
      key: "insurance",
      title: "Insurance & Medical History",
      step: MAIN_STEPS.MEDICAL_HISTORY,
      internalStep: 3,
      schema: questionBank[DMQStepNames.INSURANCE_HISTORY],
      values: fullDMQData?.[DMQStepNames.INSURANCE_HISTORY],
    },
    {
      key: "nri",
      title: "NRI Questionnaire",
      step: MAIN_STEPS.NRI_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.NRI_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.NRI_QUESTIONNAIRE],
      visible: showNRI,
    },
    {
      key: "fn",
      title: "Foreign National Questionnaire",
      step: MAIN_STEPS.FOREIGN_NATIONAL_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.FOREIGN_NATIONAL_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.FOREIGN_NATIONAL_QUESTIONNAIRE],
      visible: showFN,
    },
    {
      key: "diabetes",
      title: "Diabetic Questionnaire",
      step: MAIN_STEPS.DIABETIC_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.DIABETIC_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.DIABETIC_QUESTIONNAIRE],
      visible: showDiabetic,
    },
    {
      key: "bp",
      title: "High BP Questionnaire",
      step: MAIN_STEPS.BLOOD_PRESSURE_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.BLOOD_PRESSURE_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.BLOOD_PRESSURE_QUESTIONNAIRE],
      visible: showHighBP,
    },
    {
      key: "throid",
      title: "Thyroid Questionnaire",
      step: MAIN_STEPS.THYROID_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.THYROID_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.THYROID_QUESTIONNAIRE],
      visible: showThyroid,
    },
    {
      key: "kidney",
      title: "Kidney Questionnaire",
      step: MAIN_STEPS.KIDNEY_QUESTIONNAIRE,
      internalStep: 0,
      schema: questionBank[DMQStepNames.KIDNEY_QUESTIONNAIRE],
      values: fullDMQData?.[DMQStepNames.KIDNEY_QUESTIONNAIRE],
      visible: showKidney,
    },
  ];

  const handleVerifyOTP = async (otp) => {
    checkUserInactivity(null, async () => {
      setLoading(true);

      const currentUser = await getUser();
      const stored = getStoredFormData();
      const mappedResult = questionAnswerMapper(questionBank, stored);

      const payload = {
        memberId: currentUser?.memberId,
        qset_id: getCurrentQuestionSetId(),
        userConsent: await getClientInfo(otp),
        sections: mappedResult,
      };

      try {
        const result = await sendMemberResponse(payload);

        if (result.message === "OK") {
          setPDFPresent(false);
          navigate(appRouter.SubmissionComplete);
        }
      } catch (error) {
        setLoading(false);

        let extractedError = "";

        if (process.env.REACT_APP_ENABLE_ENCRYPTION === "true") {
          const decrypted = await decrypt(error.data);
          const parsed = JSON.parse(decrypted);
          extractedError = parsed?.message || "Something went wrong.";
        } else {
          extractedError = error?.message || error;
        }

        showCatchError(extractedError);
      }

      setFormState({});
      setLoading(false);
    });
  };

  const checkDeclaration = () => {
    const stored = getStoredFormData();
    return stored?.[DMQStepNames.DECLARATION]?.declarationCheck !== true;
  };

  return (
    <div style={{ paddingBottom: "80px" }}>
      <SystemFetchDetails
        systemDetails={fullDMQData?.[DMQStepNames.PERSONAL_DETAILS]}
        expanded={isSystemExpanded}
        confirmationPage={true}
        handleStepChange={handleStepChange}
        handleToggle={handleSystemToggle}
      />

      {sections
        .filter((section) => section.visible !== false)
        .map((section) => (
          <CustomCollapsableCard
            key={section.key}
            expanded={activeIndex === section.key}
            title={section.title}
            onToggle={() => handleToggle(section.key)}
          >
            <DynamicSummaryRenderer
              step={section.step}
              internalStep={section.internalStep}
              goToEditInformation={editInformation}
              schema={section.schema}
              values={section.values}
            />
          </CustomCollapsableCard>
        ))}

      <br />

      <DMQCustomCard title="Declaration">
        <DynamicFormRenderer_Helix
          ref={formRef}
          step={MAIN_STEPS.CONFIRM_DETAILS}
          schema={renderingJSON}
          formState={formState}
          handleChange={handleChange}
          onFormFinish={() => onFinish(formState)}
        />
      </DMQCustomCard>

      {showOTPModal && (
        <OtpVerificationModal
          visible={showOTPModal}
          onCancel={() => setShowOTPModal(false)}
          onVerify={handleVerifyOTP}
          otpLength={6}
          title="Verify My Information"
          subtitle1={`OTP sent to ${maskingUtil("email", memberDetails?.email)}`}
          subtitle2="By providing OTP, you confirm correctness."
          redirectTo={appRouter.FormFilling}
          renderAsModal
        />
      )}

      <FormFooter>
        <Button variant="primary" size="md" fullWidth onClick={() => formRef.current?.triggerNext()} disabled={checkDeclaration()}>
          Proceed to OTP Verification
        </Button>
      </FormFooter>
    </div>
  );
};

export default withAuth(StepConfirmDetails);
